import React from 'react'
import BaseInput from '../../General/FormsComp/Input/BaseInput'
import BaseSelect from '../../General/FormsComp/Select/BaseSelect'

const TIPO_CONTRATO_OPTIONS = [
    { id: 'itens', nome: 'itens' },
    { id: 'global', nome: 'global' }
]

const ContratoCadastro = ({ newClient, handleInputChange }) => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <BaseInput
                label="Nome do contrato"
                name="contrato_nome"
                value={newClient?.contrato_nome}
                onChange={handleInputChange}
                placeholder="ex.: Contrato Telefonia IP"
                type="text"
            />

            <BaseInput
                label="Número"
                name="contrato_numero"
                value={newClient?.contrato_numero}
                onChange={handleInputChange}
                placeholder="ex.: 042/2026"
                type="text"
            />

            <BaseSelect
                label="Tipo"
                name="contrato_tipo"
                value={newClient?.contrato_tipo || 'itens'}
                onChange={handleInputChange}
                options={TIPO_CONTRATO_OPTIONS}
                placeholder="Selecione o tipo"
            />

            {(newClient?.contrato_tipo || 'itens') === 'global' ? (
                <BaseInput
                    label="Valor Global (R$)"
                    name="contrato_valor"
                    value={newClient?.contrato_valor}
                    onChange={handleInputChange}
                    type="number"
                    min="0"
                    step="0.01"
                />
            ) : (
                <BaseInput
                    label="Valor (derivado dos itens)"
                    name="contrato_valor_derivado"
                    value=""
                    onChange={() => {}}
                    type="text"
                    placeholder="calculado dos itens implantados"
                    disabled
                />
            )}

            <BaseInput
                label="Início da vigência"
                name="contrato_data_inicio"
                value={newClient?.contrato_data_inicio}
                onChange={handleInputChange}
                type="date"
            />

            <BaseInput
                label="Fim da vigência"
                name="contrato_data_fim"
                value={newClient?.contrato_data_fim}
                onChange={handleInputChange}
                type="date"
            />

            <p className="aviso-contratos md:col-span-2 text-sm italic text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-700/40 border border-gray-200 dark:border-gray-600 rounded-lg p-4">
                Etapa opcional: em branco, um contrato "Contrato" é criado automaticamente
                se você cadastrar itens na próxima etapa.
            </p>
        </div>
    )
}

export default ContratoCadastro
